/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Tab_FinalsInputs */



/**
* | output |
* | --- |
* | "Finals" |
*
* @param {Tournament_Tab_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_tab_finals = /** @type {((inputs?: Tournament_Tab_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Tab_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finali")
	return /** @type {LocalizedString} */ ("Finals")
});